import React from 'react';
import AboutNav from '../Components/Navigation/AboutNav';
import Footer from '../Components/Home/Footer';
import ISOCertificateButton from '../Components/Common/ISOCertificateButton';
import '../Assets/Styles/Pages/disclosure_page.css';

const Disclosure_page = () => {
  return (
    <div className="disclosure-page">
      <AboutNav />
      
      <section className="disclosure-hero">
        <div className="disclosure-hero-content">
          <h1>SEBI Disclosure</h1>
          <p>Regulatory Compliance & Transparency Information</p>
        </div>
      </section>

      <section className="disclosure-container">
        <div className="disclosure-content">
          <div className="disclosure-header">
            <h2>DISCLOSURE</h2>
            <div className="disclosure-divider"></div>
          </div>

          <div className="disclosure-section">
            <div className="disclosure-points">
              <p>• The particulars given in this Disclosure Document have been prepared in accordance with SEBI (Research Analysts) Regulations, 2014.</p>
              <p>• The purpose of the Document is to provide essential information about the Research and recommendation Services in a manner to assist and enable the perspective client/client in making an informed decision for engaging in Research and recommendation services before investing.</p>
              <p>• For the purpose of this Disclosure Document, Research Analyst is Trillion Stock Research, (hereinafter referred as "Research Analyst")</p>
            </div>
          </div>

          <div className="disclosure-section">
            <h3>Descriptions about "Research Firm"</h3>
            
            <div className="disclosure-subsection">
              <h4>History, Present business and Background:</h4>
              <p>Research Analyst is registered with SEBI with Registration No. <strong>INH000020129</strong>. The firm got its registration on <strong>24th March, 2025</strong> and is engaged in research and recommendation Services.</p>
              <p>The focus of Research Firm is to provide research and recommendations services to the clients. Analyst aligns its interests with those of the client and seeks to provide well researched services.</p>
            </div>

            <div className="disclosure-subsection">
              <h4>Terms and conditions of Research and Recommendation Services:</h4>
              <p>Terms and conditions of Research and Recommendation Services are detailed in the terms and condition document. Please refer to the same for details.</p>
            </div>

            <div className="disclosure-subsection">
              <h4>Disciplinary history:</h4>
              <p>Terms and conditions of Research and Recommendation Services are detailed in the terms and condition document. Please refer to the same for details.</p>
              <p>There are no pending material litigations or legal proceedings, findings of inspections or investigations for which action has been taken or initiated by any regulatory authority against the Research Firm, Research Analyst or its associates or relatives.</p>
            </div>

            <div className="disclosure-subsection">
              <h4>Details of its associates:</h4>
              <p><strong>No Associates</strong></p>
            </div>
          </div>

          <div className="disclosure-section">
            <h3>Disclosures with respect to Research and Recommendations Services:</h3>
            
            <div className="disclosure-list">
              <p>• Research Firm or Research Analyst or his associate or his relative may have financial interest or actual / beneficial ownership of one per cent or more in the securities recommended in its personal portfolio at the end of the month immediately preceding the date of publication of the research report or date of the public appearance. Details of the same may be referred through the disclosures made at the time of recommendation.</p>
              
              <p>• There are no actual or potential conflicts of interest arising from any connection of Research Firm or Research Analyst or his associate or his relative to or association with any issuer of products/ securities, including any material information or facts that might compromise its objectivity or independence in the carrying on of Research Analyst services. Such conflict of interest shall be disclosed to the client as and when they arise.</p>
              
              <p>• Research analyst or research Firm or its associates or relatives, may have actual/beneficial ownership of one per cent or more securities of the subject company, at the end of the month immediately preceding the date of publication of the research report or date of the public appearance or research recommendation. Details of the same may be referred through the disclosures made at the time of recommendation.</p>
              
              <p>• Research Firm or Research analyst or its associate or relatives has no connection or association of any sort with any issuer of products/ securities recommended herein.</p>
              
              <p>• Research analyst or his associate or his relative has no actual or potential conflicts of interest arising from any connection to or association with any issuer of products/ securities, including any material information or facts that might compromise its objectivity or independence in the carrying on of research and recommendations services.</p>
              
              <p>• Research Firm or Research analyst or its associates has not received any kind of remuneration or consideration form the products/ securities recommended herein.</p>
              
              <p>• Research Firm or Research analyst or its associates have not received any compensation from the subject company in past 12 months.</p>
              
              <p>• Research Firm or Research analyst or its associates have not managed or co-managed the public offering of Subject Company in past 12 months.</p>
              
              <p>• Research Firm or Research analyst or its associates have not received any compensation for investment banking or merchant banking of brokerage services from the subject company in past 12 months.</p>
              
              <p>• Research Firm or Research analyst or its associates have received any compensation for products or services other than investment banking or merchant banking or brokerage services from the subject company in the past twelve months.</p>
              
              <p>• Research Firm or Research analyst or its associates have not received any compensation or other benefits from the subject company or third party in connection with the research report or research recommendations.</p>
              
              <p>• Research Firm or Research analyst or its associates have not received any compensation for products or services from the subject company in past 12 months.</p>
              
              <p>• The subject company is or was not a client of Research Firm or Research analyst or its associates during twelve months preceding the date of distribution of the research report and recommendation services provided.</p>
              
              <p>• Research Analysts or its associates has not served as an officer, director or employee of the subject company.</p>
              
              <p>• Research Analysts has not been engaged in market making activity of the subject company.</p>
            </div>
          </div>

          <div className="disclosure-footer">
            <div className="disclosure-note">
              <h4>Important Note:</h4>
              <p>This disclosure document is prepared in compliance with SEBI (Research Analysts) Regulations, 2014. For any queries regarding this disclosure, please contact our compliance team.</p>
            </div>
            
            <div className="disclosure-contact">
              <p><strong>SEBI Registration No.:</strong> INH000020129</p>
              <p><strong>Registration Date:</strong> 24th March, 2025</p>
              <p><strong>Contact:</strong> mail.trillionstockresearch@gmail.com</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <ISOCertificateButton />
    </div>
  );
};

export default Disclosure_page;

